<template>
  <div class="stats">
    <!-- <p class="page-tit" :style="{ color: headType === '2' ? '#B9A2C9' : '' }">
      {{ $t("basketball.nav1") }}
    </p> -->
    <div class="stats-box">
      <div class="stats-bg">
        <el-tabs
          type="border-card"
          class="istab-bg"
          :class="{ 'tab-color': headType === '2' }"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane name="tab1" :label="$t('stats.player')"
            ><Stats1 ref="playerStats" :tabName="activeName" :isyear="year"
          /></el-tab-pane>
          <el-tab-pane name="tab2" :label="$t('stats.team')"
            ><Stats2 ref="teamStats" :tabName="activeName" :isyear="year"
          /></el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Stats1 from "./components/stats/StatsPlayer.vue";
import Stats2 from "./components/stats/StatsTeam.vue";
import { mapState } from "vuex";

export default {
  components: {
    Stats1,
    Stats2
  },
  props: ["year"],
  data() {
    return {
      activeName: "tab1",
      tablist: [{ tabname: "PLAYER" }, { tabname: "TEAM" }]
    };
  },
  computed: {
    ...mapState(["headType"])
  },
  methods: {
    handleClick() {
      if (this.activeName == "tab1") {
        this.$refs.playerStats.tabChange();
      } else {
        this.$refs.teamStats.tabChange();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.playerStats.tabChange();
    });
  },
  created() {
    // this.$refs.playerStats.tabChange()
  }
};
</script>
<style lang="scss">
.stats {
  .el-tabs {
    .el-tabs__header {
      margin: 0;
      border-bottom: none;
      .el-tabs__nav-wrap {
        .el-tabs__nav-scroll {
          .el-tabs__nav {
            border: none;
            float: none;
            display: flex;
            justify-content: space-around;
          }
        }
      }
    }
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border: none;
    background: #318bc8;
    border-radius: 15px 15px 0 0;
    color: #fff;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border: none;
    padding: 10px 20px;
    height: auto;
    color: #318bc8;
    width: 50%;
  }
  .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.stats {
  .page-tit {
    color: #318bc8;
    font-weight: 600;
    font-size: 22px;
    margin: 20px 0 50px 0;
  }
  .stats-box {
    box-shadow: 2px 2px 15px #8888886c;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    .stats-bg {
      background: #fff;
      overflow: hidden;
    }
  }
}
</style>
